// extracted by mini-css-extract-plugin
export default {"sectionContainer":"styles_sectionContainer__UwjPD","title":"styles_title__Dg8Xm","imgCon":"styles_imgCon__l1Dpn","btn":"styles_btn__HDpUx","fadeInUp":"styles_fadeInUp__TNJmI"};